import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid sm:grid-cols-2 pb-6" }
const _hoisted_2 = { class: "title w-full" }
const _hoisted_3 = ["data-tip"]
const _hoisted_4 = {
  class: "tooltip",
  "data-tip": "Show graph"
}
const _hoisted_5 = { class: "btn btn-sm btn-ghost" }
const _hoisted_6 = { class: "join w-min" }
const _hoisted_7 = { class: "join w-min" }

import { assertUnreachable } from "@/utils";
import { useHelpStore, useKeyboardStore } from "@/stores";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import PopupButton from "@/components/utils/PopupButton.vue";
import ToggleOption from "@/components/settings/ToggleOption.vue";
import SpeedProfilePlot from "@/components/mouse/SpeedProfilePlot.vue";

type AxesTyple = typeof AXES;
type Axis = AxesTyple[number];


export default /*@__PURE__*/_defineComponent({
  __name: 'MouseArea',
  setup(__props) {

const kb = useKeyboardStore();
const help = useHelpStore();

const AXES = ["x", "y", "wheel", "pan"] as const;
const titleCase = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
const headerTooltip = (axis: Axis) => {
  const start = "Mouse emulation speed profile used when";
  if (axis == "x" || axis == "y")
    return `${start} moving in ${axis.toUpperCase()} direction`;
  else if (axis == "wheel") return `${start} scrolling with wheel`;
  else if (axis == "pan") return `${start} panning (scrolling horizontally)`;
  else return assertUnreachable(axis);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(AXES, (axis) => {
      return _createElementVNode("div", {
        key: axis,
        class: _normalizeClass(["px-4 max-w-xs", axis == AXES[0] ? 'tour-mouse-config' : ''])
      }, [
        _createElementVNode("h1", _hoisted_2, [
          _createElementVNode("div", {
            class: "tooltip px-3",
            "data-tip": headerTooltip(axis)
          }, _toDisplayString(titleCase(axis) + " speed profile"), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(PopupButton, {
              placement: 'auto',
              offset: 4,
              renderOnShow: true,
              class: _normalizeClass(axis == AXES[0] ? 'tour-mouse-plot-btn' : ''),
              "force-show": axis == AXES[0] && _unref(help).showMousePlot
            }, {
              button: _withCtx(() => [
                _createElementVNode("button", _hoisted_5, [
                  _createVNode(_component_Icon, { icon: "mdi:chart-line" })
                ])
              ]),
              popup: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-[400px] sm:w-[600px] p-4 pt-5 pr-5", axis == AXES[0] ? 'tour-mouse-plot' : ''])
                }, [
                  _createVNode(SpeedProfilePlot, {
                    profile: _unref(kb).config.mouse[axis].profile,
                    width: 0.5,
                    height: 0.5
                  }, null, 8, ["profile"])
                ], 2)
              ]),
              _: 2
            }, 1032, ["class", "force-show"])
          ])
        ]),
        _createVNode(ToggleOption, {
          label: "Invert direction",
          tooltip: "Invert axis movement direction",
          modelValue: _unref(kb).config.mouse[axis].invert,
          "onUpdate:modelValue": ($event: any) => ((_unref(kb).config.mouse[axis].invert) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(SettingsOption, {
          label: "Divider",
          tooltip: "Controls output speed scaling"
        }, {
          default: _withCtx(() => [
            _createVNode(IntegerInput, {
              class: "w-[11ch] input-sm",
              min: 0,
              max: 65535,
              modelValue: _unref(kb).config.mouse[axis].profile.divider,
              "onUpdate:modelValue": ($event: any) => ((_unref(kb).config.mouse[axis].profile.divider) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024),
        _createVNode(SettingsOption, {
          label: "Delay",
          tooltip: "Delay in milliseconds from the moment key is pressed to when start speed is applied"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(IntegerInput, {
                class: "w-[9ch] input-sm join-item",
                min: 0,
                max: 65535,
                modelValue: _unref(kb).config.mouse[axis].profile.delay,
                "onUpdate:modelValue": ($event: any) => ((_unref(kb).config.mouse[axis].profile.delay) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm" }, "ms", -1))
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(SettingsOption, {
          label: "Acceleration time",
          tooltip: "Time it takes (in milliseconds) to accelerate from start speed to max speed"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(IntegerInput, {
                class: "w-[9ch] input-sm join-item",
                min: 0,
                max: 65535,
                modelValue: _unref(kb).config.mouse[axis].profile.acceleration_time,
                "onUpdate:modelValue": ($event: any) => ((_unref(kb).config.mouse[axis].profile.acceleration_time) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "join-item btn-input-unit btn-input-unit-sm" }, "ms", -1))
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(SettingsOption, {
          label: "Start speed",
          tooltip: "Initial speed value"
        }, {
          default: _withCtx(() => [
            _createVNode(IntegerInput, {
              class: "w-[11ch] input-sm",
              min: 0,
              max: 65535,
              modelValue: _unref(kb).config.mouse[axis].profile.start_speed,
              "onUpdate:modelValue": ($event: any) => ((_unref(kb).config.mouse[axis].profile.start_speed) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024),
        _createVNode(SettingsOption, {
          label: "Max speed",
          tooltip: "Final speed reached after delay + acceleration time since key press"
        }, {
          default: _withCtx(() => [
            _createVNode(IntegerInput, {
              class: "w-[11ch] input-sm",
              min: 0,
              max: 65535,
              modelValue: _unref(kb).config.mouse[axis].profile.max_speed,
              "onUpdate:modelValue": ($event: any) => ((_unref(kb).config.mouse[axis].profile.max_speed) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1024)
      ], 2)
    }), 64))
  ]))
}
}

})